// extracted by mini-css-extract-plugin
export var crossfade = "crossfade-module--crossfade--OZPGm";
export var crossfadeTop = "crossfade-module--crossfade-top--D3Oje";